import { DialogContentText, styled } from "@mui/material";

const ErrorDialogContentText = styled(DialogContentText)(({ theme }) => ({
  color: theme.palette.error.main,
}));

export default ErrorDialogContentText;
